import { withInstall } from '../../../../utils/with-install'
import Video from './Video.vue'

export const ElAmapLayerVideo = withInstall(Video)
export default ElAmapLayerVideo
